export const version = 'kunde-v1.20.0-SNAPSHOT-f5660b8d24a31ae2127c89f3406fe957a1c2744f';